import React, { Fragment, useMemo, useEffect, } from 'react';
import { useList, useToggle, useCounter, useAsync, } from 'react-use';
import { useLocation, useHistory, } from 'react-router';
import { fromPairs, keyBy, pick, } from 'lodash';
import { startOfMonth, startOfDay, endOfDay, addDays, } from 'date-fns';
import { Button, Modal, ModalBody, ModalHeader, ModalFooter, Form, } from 'reactstrap';
import { addDoc, collection, query, where, orderBy as dbOrderBy, limit, getCountFromServer, getAggregateFromServer, sum as dbSum, count as dbCount, } from 'firebase/firestore';
import { toast } from 'react-toastify';
import dedent from 'dedent';
import numeral from 'numeral';

import firebase, { functions } from '../firebase';
import useFirebaseUser from './hooks/useFirebaseUser';
import useUser from './hooks/useUser';
import useFormState from './hooks/useFormState';
import HeaderNav from './HeaderNav';
import Field from './Field';

const { keys, entries } = Object;

export default function Page (props) {
  const { children, admin, tenant } = props;
  const { firebaseUser } = useFirebaseUser();
  const history = useHistory();
  const location = useLocation();
  useEffect(() => {
    if(firebaseUser != null && location.pathname === '/signUp') {
      history.replace('/');
    }
  }, [firebaseUser != null, location]);

  return (
    <div className="page h-100">
      <div className="d-flex flex-column" style={{ minHeight: '100vh' }}>
        <HeaderNav {...{ ...props, admin, tenant }} />
        <div className="flex-fill">
          {children}
        </div>
        {!admin && tenant && (
          <div className="position-fixed" style={{ bottom: 15, right: 15, zIndex: 1030 }}>
            <InquiryButton tenant={tenant} />
          </div>
        )}
      </div>
    </div>
  );
};

function InquiryButton ({ tenant }) {
  const { user } = useUser();
  const [showsModal, toggleModal] = useToggle(false);
  const [isSubmitting, toggleSubmitting] = useToggle(false);
  const statedFields = useFormState({}, { body: { type: 'text', label: 'お問い合わせ内容' } }, false);
  const onSubmit = async (event) => {
    event.preventDefault();
    toggleSubmitting(true);
    try {
      await addDoc(collection(tenant.ref, 'inquiries'), {
        body: statedFields.body.value,
        createdBy: pick(user, ['id', 'email', 'displayName']),
        createdAt: new Date(),
      });
      toast.success(dedent`
        お問い合わせ頂きまして、ありがとうございます！
        カスタマーサポートが1営業日以内にご返信致しますので
        今しばらくお待ち下さいませ。

        サポート対応日時：10時〜17時（土日祝除く）
      `);
      toggleModal(false);
      statedFields.body.setValue('');
    } catch (e) {
      console.error(e);
      toast.error('失敗しました');
    }
    toggleSubmitting(false);
  };

  return (
    <Fragment>
      <Button color="info" className="rounded-pill px-3 py-2 text-white shadow" onClick={() => toggleModal(true)}>
        <span className="fas fa-question me-2" />
        サポート
      </Button>
      {showsModal && (
        <Modal isOpen>
          <ModalHeader>お問い合わせ</ModalHeader>
          <Form onSubmit={onSubmit}>
            <ModalBody>
              <div className="alert alert-warning">
                <div className="fw-bold mb-2">
                  <span className="fas fa-book me-2" />
                  お問い合わせの前にご利用ガイドをご確認ください
                </div>
                <div className="mb-2">
                  よくあるご質問や操作方法は、ご利用ガイドに掲載しております。
                </div>
                <a
                  href="https://www.notion.so/wizzlinx/Totono-365aaa5b8edf80779f76c1bf25d15d23?source=copy_link&utm_content=365aaa5b-8edf-8077-9f76-c1bf25d15d23&utm_campaign=T9R9JDF7S&pvs=6"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-warning"
                >
                  <span className="fas fa-external-link-alt me-2" />
                  ご利用ガイドを開く
                </a>
              </div>
              <div className="alert alert-info">
                ご利用ガイドで解決しない場合は、以下よりお問い合わせください。
                <br />
                サポート対応日時：10時〜17時（土日祝除く）
              </div>
              {entries(statedFields).map(([fieldName, fieldSetting]) => (
                <Field
                  key={fieldName}
                  name={fieldName}
                  {...fieldSetting}
                  rows={5}
                />
              ))}
            </ModalBody>
            <ModalFooter>
              <Button color="secondary" onClick={() => toggleModal(false)}>閉じる</Button>
              <Button type="submit" color="primary" disabled={isSubmitting || !statedFields.body.value}>送信</Button>
            </ModalFooter>
          </Form>
        </Modal>
      )}
    </Fragment>
  );
}
